<template>
<div class="col-md-12 col-sm-12 col-xs-12 info-form-content p-l-r-0">
    <!-- <a href="#" class="preview " id="opcpreview-btn" v-on:click="ifpreviewopen3()">
        <img src="../assets/privew-icon.png">
    </a>
    <a href="#" class="preview preview_btn-width" id="opcpreview-close-btn" v-on:click="ifpreviewclose3()" style="display: none;">
        <img src="../assets/close-icon.png">
    </a> -->

    <div class="opc_form_block" id="opc_form_block"  v-if="form_status">
        <div class="opc-accordion" id="accordionopc" role="tablist">
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordionopc-1 variant="info">Director Details (OPC) <span class="accordion_arrow"><img src="../assets/icon-19.png"></span></b-button>
                </b-card-header>
                <b-collapse id="accordionopc-1" visible accordion="opc-accordion" role="tabpanel">
                    <b-card-body>
                        <form>
                            <!-- <div class="col-md-12 p-l-r-0 f-left text-right edit_icon">
                                <a href="#"><img src="../assets/edit_icon.png"></a>
                            </div> -->
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="name">Name (in full)*</label>
                                    <input type="text" class="form-control" id="name" v-model="owner_information.name">
                                     <span class="text-danger" v-if="validation_errors.name">Please enter name</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="fname">Father’s Name (in full)*</label>
                                    <input type="text" class="form-control" id="fname" v-model="owner_information.father_name">
                                    <span class="text-danger" v-if="validation_errors.father_name">Please enter father name</span>
                                </div>
                            </div>

                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="mobile_no">Mobile Number*</label>
                                    <input type="text" class="form-control" id="mobile_no" v-model="owner_information.mobile_no">
                                    <span class="teptext">(Linked with Aadhar)</span>
                                     <span class="text-danger" v-if="validation_errors.mobile_no">{{validation_errors.mobile_no}}</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="email_id">Email ID*</label>
                                    <input type="text" class="form-control" id="email_id" v-model="owner_information.email_id">
                                     <span class="text-danger" v-if="validation_errors.email_id">{{validation_errors.email_id}}</span>
                                </div>
                            </div>

                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="Birth">Date of Birth*</label>
                                    <!-- <input type="text" class="form-control" id="Birth" v-model="owner_information.dob"> -->
                                    <Datepicker class="form-control" v-model="owner_information.dob"></Datepicker>
                                    <span class="text-danger" v-if="validation_errors.dob">Please select date of birth</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="Qualification">Highest Educational Qualification*</label>
                                    <input type="text" class="form-control" id="Qualification" v-model="owner_information.higest_education">
                                     <span class="text-danger" v-if="validation_errors.higest_education">Please enter higest education</span>
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="Occupation">Occupation*</label>
                                    <input type="text" class="form-control" id="Occupation" v-model="owner_information.occupation">
                                     <span class="text-danger" v-if="validation_errors.occupation">Please enter occupation</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="ownerPanNumber">PAN Number*</label>
                                    <input type="text" class="form-control" id="ownerPanNumber" v-model="owner_information.pan_number">
                                    <span class="text-danger" v-if="validation_errors.pan_number">Please enter pan number</span>
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="ownerAddress">Address*</label>
                                    <textarea class="form-control form_textarea" rows="4" id="address" v-model="owner_information.address"></textarea>
                                     <span class="text-danger" v-if="validation_errors.address">Please enter address</span>
                                </div>
                            </div>
                            <!-- <proof_upload/> -->
                            <div class="col-md-12 p-l-r-0 f-left proof_upload">
                                <div class="col-md-12 p-l-r-0 f-left">
                                    <div class="form-group col-md-6 p-l-r-0 f-left choosefile-upload">
                                        <address_proof_acc v-bind:propdata="props_from_parent" v-bind:from_key="0" @UpdateFilePath="UpdateFilePath" />
                                        <span id="file-chosen" v-if="owner_information.address_proff">
                                            <a :href="owner_information.address_proff" target="_blank">view</a>
                                        </span>
                                        <span class="text-danger" v-if="validation_errors.address_proff">Please upload address proof</span>
                                    </div>
                                    <div class="form-group col-md-6 p-r-0 f-left choosefile-upload">
                                        <pan_upload v-bind:propdata="props_from_parent" v-bind:from_key="0" @UpdateFilePath="UpdateFilePath" />
                                        <span id="file-chosen" v-if="owner_information.pan_url">
                                            <a :href="owner_information.pan_url" target="_blank">view</a>
                                        </span>
                                        <span class="text-danger" v-if="validation_errors.pan_url">Please update self-attested PAN document</span>
                                    </div>
                                    <div class="form-group col-md-6 p-l-r-0 f-left choosefile-upload">
                                        <aadhar_upload v-bind:propdata="props_from_parent" v-bind:from_key="0" @UpdateFilePath="UpdateFilePath" />
                                        <span id="file-chosen" v-if="owner_information.aadhar_url">
                                            <a :href="owner_information.aadhar_url" target="_blank">view</a>
                                        </span>
                                        <span class="text-danger" v-if="validation_errors.aadhar_url">Please update self-attested Aadhar document</span>
                                    </div>
                                    <div class="form-group col-md-6 p-r-0 f-left choosefile-upload">
                                        <photo_upload v-bind:propdata="props_from_parent" v-bind:from_key="0" @UpdateFilePath="UpdateFilePath" />
                                        <span id="file-chosen" v-if="owner_information.passport_size_photo">
                                            <a :href="owner_information.passport_size_photo" target="_blank">view</a>
                                        </span>
                                         <span class="text-danger" v-if="validation_errors.passport_size_photo">Please update passport size photo</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left border-seperator"></div>

                            <!-- digitel_signature -->
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="col-md-12 p-l-r-0 f-left">
                                    <div class="form-group col-md-6 p-l-r-0 f-left">
                                        <label for="Qualification">Do you have Digital Signature Certificate?*</label><br>
                                        <label class="radio-container">Yes
                                            <input type="radio" value="yes" v-model="owner_information.dsc" v-on:click="ifyessignature('yes')">
                                            <span class="checkmark"></span>
                                        </label>
                                        <label class="radio-container">No
                                            <input type="radio" value="no" v-model="owner_information.dsc" v-on:click="ifyessignature('no')">
                                            <span class="checkmark"></span>
                                        </label>
                                        <span class="text-danger" v-if="validation_errors.dsc">Please select</span>
                                        <!-- <p class="signaure-text" :id="'signaure-text'" style="color: #F75511;">Upon form completion and its approval by your accounting manager, an option to add DSC will be enabled for forms MBP-1 and DIR-2.</p> -->
                                    </div>
                                    <div class="form-group col-md-6 p-r-0 f-left">
                                        <label for="Qualification">Do you have Director Identification Number (DIN)?*</label><br>
                                        <label class="radio-container">Yes
                                            <input type="radio" value="yes" v-model="owner_information.din" >
                                            <span class="checkmark"></span>
                                        </label>
                                        <label class="radio-container">No
                                            <input type="radio" value="no" v-model="owner_information.din">
                                            <span class="checkmark"></span>
                                        </label>
                                        <span class="text-danger" v-if="validation_errors.din">Please select</span>
                                        <input type="text" class="form-control" style="margin-top: 10px;" v-model="owner_information.din_other" v-if="owner_information.din=='yes'"  placeholder="Enter DIN">
                                    </div>
                                </div>
                                <div class="col-md-12 p-l-r-0 f-left">
                                    <div class="form-group col-md-6 p-l-r-0 f-left">
                                        <label for="Qualification">    Are you an Indian citizen?* </label><br>
                                        <label class="radio-container">Yes
                                            <input type="radio" value="yes" v-model="owner_information.citizen_of_india" >
                                            <span class="checkmark"></span>
                                        </label>
                                        <label class="radio-container">No
                                            <input type="radio" value="no" v-model="owner_information.citizen_of_india">
                                            <span class="checkmark"></span>
                                        </label>
                                        <span class="text-danger" v-if="validation_errors.citizen_of_india">Please select</span>
                                        <input type="text" class="form-control" style="margin-top: 10px;" v-if="owner_information.citizen_of_india=='no'" v-model="owner_information.citizen_of_other" id="Country_name" placeholder="Country Name*">

                                    </div>
                                    <div class="form-group col-md-6 p-r-0 f-left intrestedentity">
                                        <label for="entity">    Do you have an interest in any other entity?*</label><br>
                                        <label class="radio-container">Yes
                                            <input type="radio" value="yes" v-model="owner_information.intrested_in_other_entity" v-on:click="ifyesintrest('yes')">
                                            <span class="checkmark"></span>
                                        </label>
                                        <label class="radio-container">No
                                            <input type="radio" value="no" v-model="owner_information.intrested_in_other_entity" v-on:click="ifyesintrest('no')">
                                            <span class="checkmark"></span>
                                        </label>
                                         <span class="text-danger" v-if="validation_errors.intrested_in_other_entity">Please select</span>
                                    </div>
                                </div>

                            </div>
                            <!-- digitel_signature end -->
                            <!-- nature_interest -->
                            <div class="col-md-12 p-l-r-0 f-left">
                                
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left nature_interest_form" id="nature_interest_form" >
                                <div class="col-md-12 p-l-r-0 f-left sub-text">
                                    <span class="teptext">Nature of interest (owner/partner/director etc.)*</span>
                                </div>
                                <div v-for="(list,listkey) in owner_information.nature_interest_list" :key="listkey" class="col-md-12 f-left nature_interest_box" style="padding-bottom:10px">
                                    <a href="javascript://" v-if="listkey>0" @click="RemoveIntrestList(listkey,key)">Remove</a>
                                    <div class="col-md-12 p-l-r-0 f-left">
                                        <div class="form-group col-md-6 p-l-r-0 f-left">
                                            <label for="nEntity">Name of the Entity*</label>
                                            <input type="text" class="form-control" v-model="list.entity_name" id="nEntity">
                                        </div>
                                        <div class="form-group col-md-6 p-r-0 f-left">
                                            <label for="nInterest">Nature of interest (owner/partner/director etc.)*</label>
                                            <input type="text" class="form-control" v-model="list.nature_interest_interest" id="nInterest">
                                        </div>
                                    </div>
                                    <div class="col-md-12 p-l-r-0 f-left">
                                        <div class="form-group col-md-6 p-l-r-0 f-left">
                                            <label for="inr">Value in INR*</label>
                                            <input type="text" class="form-control" v-model="list.value" id="inr">
                                        </div>
                                        <div class="form-group col-md-6 p-r-0 f-left">
                                            <label for="'datepicker'">Date*</label>

                                            <!-- <input type="text" class="form-control" v-model="list.date" id="datepicker"> -->
                                            <Datepicker class="form-control" v-model="list.date"></Datepicker>
                                            <span class="teptext">on which Interest arose</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="pluse-icon">
                                    <a href="javascript://" @click="NaruteoFPlus()"><img src="../assets/pluse-icon.png"></a>
                                </div>

                            </div>
                            <!-- nature_interest end -->
                            <div class="col-md-12 p-l-r-0 f-left submit_btn_margin">
                                <button type="button" class="btn btn-primary gobtn submit" @click="Submit()">Submit</button>
                            </div>
                        </form>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordionopc-2 variant="info">Nominee Details (OPC) <span class="accordion_arrow"><img src="../assets/icon-19.png"></span></b-button>
                </b-card-header>
                <b-collapse id="accordionopc-2" accordion="opc-accordion" role="tabpanel">
                    <b-card-body>
                        <form>
                            <!-- <div class="col-md-12 p-l-r-0 f-left text-right edit_icon">
                                <a href="#"><img src="../assets/edit_icon.png"></a>
                            </div> -->
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="name">Name (in full)*</label>
                                    <input type="text" class="form-control" id="name" v-model="nominee_information.name">
                                     <span class="text-danger" v-if="nominee_errors.name">Please enter name</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="fname">Father’s Name (in full)*</label>
                                    <input type="text" class="form-control" id="fname" v-model="nominee_information.father_name">
                                      <span class="text-danger" v-if="nominee_errors.father_name">Please enter father name</span>
                                </div>
                            </div>

                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="mobile_no">Mobile Number*</label>
                                    <input type="text" class="form-control" id="mobile_no" v-model="nominee_information.mobile_no">
                                    <span class="teptext">(Linked with Aadhar)</span>
                                     <span class="text-danger" v-if="nominee_errors.mobile_no">{{validation_errors.mobile_no}}</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="email_id">Email ID*</label>
                                    <input type="text" class="form-control" id="email_id" v-model="nominee_information.email_id">
                                    <span class="text-danger" v-if="nominee_errors.email_id">{{validation_errors.email_id}}</span>   
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="Birth">Date of Birth*</label>
                                    <!-- <input type="text" class="form-control" id="Birth" v-model="nominee_information.dob"> -->
                                    <Datepicker class="form-control" v-model="nominee_information.dob"></Datepicker>
                                     <span class="text-danger" v-if="nominee_errors.dob">Please select date of birth</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="Qualification">Highest Educational Qualification*</label>
                                    <input type="text" class="form-control" id="Qualification" v-model="nominee_information.higest_education">
                                     <span class="text-danger" v-if="nominee_errors.higest_education">Please enter higest education</span>
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="Occupation">Occupation*</label>
                                    <input type="text" class="form-control" id="Occupation" v-model="nominee_information.occupation">
                                    <span class="text-danger" v-if="nominee_errors.occupation">Please enter occupation</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="PanNumber">PAN Number*</label>
                                    <input type="text" class="form-control" id="PanNumber" v-model="nominee_information.pan_number">
                                     <span class="text-danger" v-if="nominee_errors.pan_number">Please enter pan number</span>
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="address">Address*</label>
                                    <textarea class="form-control form_textarea" rows="4" id="address" v-model="nominee_information.address"></textarea>
                                     <span class="text-danger" v-if="nominee_errors.address">Please enter address</span>
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left border-seperator"></div>

                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="Qualification">Are you an Indian citizen?*</label><br>
                                    <label class="radio-container">Yes
                                        <input type="radio" name="Citizen" value="yes" v-model="nominee_information.citizen_of_india" >
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-container">No
                                        <input type="radio" name="Citizen" value="no" v-model="nominee_information.citizen_of_india" >
                                        <span class="checkmark"></span>
                                    </label>
                                     <span class="text-danger" v-if="nominee_errors.citizen_of_india">Please select</span>
                                    <input type="text" class="form-control" v-if="nominee_information.citizen_of_india=='no'" style="margin-top: 10px;" v-model="nominee_information.citizen_of_other" id="Country_names" placeholder="Country Name*">
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="Qualification">Do you have Director Identification Number (DIN)?*</label><br>
                                    <label class="radio-container">Yes
                                        <input type="radio" name="Identification" value="yes" v-model="nominee_information.din" >
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-container">No
                                        <input type="radio" name="Identification" value="no" v-model="nominee_information.din">
                                        <span class="checkmark"></span>
                                    </label>
                                     <span class="text-danger" v-if="nominee_errors.din">Please select</span>
                                    <input type="text" class="form-control "  v-if="nominee_information.din=='yes'" v-model="nominee_information.din_other" id="opcdin_text_box" placeholder="Enter DIN">
                                </div>
                            </div>

                            <div class="col-md-12 p-l-r-0 f-left ">
                                <button type="button" class="btn btn-primary gobtn submit" @click="nomineeSubmit()">Submit</button>
                            </div>
                        </form>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordionopc-3 variant="info">Other Details (OPC) <span class="accordion_arrow"><img src="../assets/icon-19.png"></span></b-button>
                </b-card-header>
                <b-collapse id="accordionopc-3" accordion="opc-accordion" role="tabpanel" class="other_details-sec">
                    <b-card-body>
                        <form>
                            <div class="col-md-12 p-l-r-0 f-left text-right edit_icon" style="margin-bottom: 0px">
                                <a href="#"><img src="../assets/edit_icon.png"></a>
                            </div>
                            <other_details :parentName="'opcName'" :propdata="other_details" @other_update="saveSuccess" />
                        </form>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
    </div>
    <div  v-else class="opc_form_priview_block priview_block" id="opc_form_priview_block" >
        <opc_form_preview :prop_owners="owner_information" :prop_others="other_details" :prop_nominee="nominee_information" />
    </div>
</div>
</template>

<script>
import company_info from "../services/company_info"
import address_proof_acc from './address_proof';
import aadhar_upload from './aadhar_upload';
import photo_upload from './photo_upload';
import pan_upload from './pan_upload';
import other_details from './other_details';
import opc_form_preview from './opc_form_preview';
import Datepicker from 'vuejs-datepicker';

export default {
    name: 'opc_accordion.vue',
    props: ['subscription_params'],
    watch: {
        subscription_params: {
            handler: function () {
                this.InitPrepareForm();
            },
            immediate: true
        },

    },
    components: {
        // proof_upload,
        // digitel_signature,
        // nature_interest,
        other_details,
        opc_form_preview,
        address_proof_acc,
        aadhar_upload,
        pan_upload,
        photo_upload,
        Datepicker
    },
    data() {
        return {
            form_status:true,
            other_details: {
                subscription_id: this.subscription_params.subscribtion_id,
                website: '',
                entity: 'OPC',
                brief_note: '',
                proposed_company_name_option1: '',
                proposed_company_name_option2: '',
                authorized_capital: '',
                paid_up_capital: '',
                registered_office: '',
                other_documents: ''

            },
            validation_errors: {
            },
            nominee_errors: {
            },
			owner_information:{
				name: '',
                father_name: '',
                mobile_no: '',
                email_id: '',
                dob: '',
                higest_education: '',
                occupation: '',
                pan_number: '',
                address: '',
                aadhar_url: '',
                pan_url: '',
                address_proff: '',
                passport_size_photo: '',
                dsc: '',
                din: '',
				din_other:'',
                citizen_of_india: '',
                citizen_of_other: '',
                intrested_in_other_entity: '',
                ownership_percentage: '',
                nature_interest: '',
				nature_interest_list:[]
			},
            nominee_information: {
                name: '',
                father_name: '',
                mobile_no: '',
                email_id: '',
                dob: '',
                higest_education: '',
                occupation: '',
                citizen_of_india: '',
                citizen_of_other: '',
				din:'',
				din_other:'',
                address:''
            }
        }
    },
    methods: {
        InitPrepareForm() {
            var db_params = this.subscription_params.company_info;
            if (db_params) {
                 this.form_status=db_params.status=='pending' ? true :false;
                if (db_params.other_details) {
                    this.other_details = JSON.parse(db_params.other_details);
                }
                if (db_params.nominee_details) {
                    console.log(db_params.nominee_details);
                    this.nominee_information = JSON.parse(db_params.nominee_details);
                }
                if (this.subscription_params.company_info.onwer_information) {
                    var res_format = JSON.parse(db_params.onwer_information);
                        this.owner_information=res_format;

                } else {
                    this.prePareForm();
                }
            } else {
                this.prePareForm();
            }

            this.UpdateChildPropData();
        },
        saveSuccess(payload){
             this.$emit("saveSuccessToparent", {
                    src: payload.src
                });
        },
        prePareForm() {
        },
        UpdateChildPropData() {
            this.props_from_parent = this.subscription_params
            this.props_from_parent.date = new Date()

        },
        UpdateFilePath(payload) {
            if (payload.src == 'address_proff') {
                this.owner_information.address_proff = payload.url;
            }
            if (payload.src == 'aadhar_url') {
                this.owner_information.aadhar_url = payload.url;
            }
            if (payload.src == 'pan_url') {
                this.owner_information.pan_url = payload.url;
            }
            if (payload.src == 'passport_size_photo') {
                this.owner_information.passport_size_photo = payload.url;
            }
        },
        ifyesintrest(option) {
            if (option == 'yes') {
                document.getElementById('nature_interest_form').style.display = 'block';
                this.NaruteoFPlus()
            } else {
                this.owner_information.nature_interest_list = []
                document.getElementById('nature_interest_form').style.display = 'none';
            }
        },
        NaruteoFPlus() {
            this.owner_information.nature_interest_list.push({
                entity_name: '',
                nature_interest_interest: '',
                value: '',
                date: ''
            });
        },
        RemoveIntrestList(listKey) {
            this.owner_information.nature_interest_list.splice(listKey, 1);
        },
        ifyessignature(option) {
            if (option == 'yes') {
                document.getElementById('signaure-text').style.display = 'block';
            } else {
                document.getElementById('signaure-text').style.display = 'none';
            }
        },
		 Submit() {
             this.validation_errors={}
            company_info.post({
                    onwer_information: this.owner_information,
                    onwer_information_all: this.owner_information,
                    subscription_id: this.subscription_params.subscribtion_id,
                    no_of_owners: 1,
                    entity: 'OPC',
                })
                .then(response => {
                    if (response.data.status == 'success') {
                        this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'success',
                            text: 'Details saved successfully',
                            ignoreDuplicates: true
                        });
                    }
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'warn',
                            text: 'Please fill all required fields',
                            ignoreDuplicates: true
                        });
                        var err=error.response.data.status;
                        var temp={};
                        Object.keys(err).forEach((key) => {
                            var err_text=err[key][0].split(".");
                            temp[key.split(".")[1]]=err_text[1]
                        });
                        this.validation_errors=temp
                    }
                })
        },
		nomineeSubmit() {
            company_info.postNomineeDetails({
                    nominee_information: this.nominee_information,
                    subscription_id: this.subscription_params.subscribtion_id,
                    no_of_owners: 1,
                    entity: 'OPC',
                })
                .then(response => {
                    if (response.data.status == 'success') {
                        this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'success',
                            text: 'Details saved successfully',
                            ignoreDuplicates: true
                        });
                    }
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'warn',
                            text: 'Please fill all required fields',
                            ignoreDuplicates: true
                        });
                        var err=error.response.data.status;
                        var temp={};
                        Object.keys(err).forEach((key) => {
                            var err_text=err[key][0].split(".");
                            temp[key.split(".")[1]]=err_text[1]
                        });
                        this.nominee_errors=temp

                    }
                })
        },
        
        ifpreviewopen3() {
            document.getElementById('opc_form_priview_block').style.display = 'block';
            document.getElementById('opc_form_block').style.display = 'none';
            document.getElementById('opcpreview-btn').style.display = 'none';
            document.getElementById('opcpreview-close-btn').style.display = 'block';
        },
        ifpreviewclose3() {
            document.getElementById('opc_form_priview_block').style.display = 'none';
            document.getElementById('opc_form_block').style.display = 'block';
            document.getElementById('opcpreview-btn').style.display = 'block';
            document.getElementById('opcpreview-close-btn').style.display = 'none';
        },
        
		
    }
};
</script>
